import { render, staticRenderFns } from "./changeMaterial.vue?vue&type=template&id=1291e6d4&scoped=true"
import script from "./changeMaterial.vue?vue&type=script&lang=js"
export * from "./changeMaterial.vue?vue&type=script&lang=js"
import style0 from "./changeMaterial.vue?vue&type=style&index=0&id=1291e6d4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1291e6d4",
  null
  
)

export default component.exports